import { canChangeShippingAddress } from '@printdeal/business-logic';
import { SanitizedLineItem } from '../../../../../../types/order/Order';
import { Environment } from '../../../../../../helpers/env';

const ReasonsDisabled = {
  HAS_MULTIPLE_ADDRESSES: 'Has multiple addresses', // Note, we simply have not yet built a way to accommodate this.
  ADDRESSES_LOCKED_DUE_TO_STATE: 'Addresses for cancelled and shipped items are locked',
};

const canChangeShippingAddressHelper = (lineItem: SanitizedLineItem) => {
  const { shippingAddresses } = lineItem.sane;

  if (shippingAddresses.length > 1) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.HAS_MULTIPLE_ADDRESSES,
    };
  }

  if (!canChangeShippingAddress(Environment, lineItem)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.ADDRESSES_LOCKED_DUE_TO_STATE,
    };
  }

  return {
    enabled: true,
  };
};

export default canChangeShippingAddressHelper;
